import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const StyledSubStack = styled(Stack)(({ theme }) => ({
  padding: "15px",
  borderRight: "1px solid",
  borderLeft: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
}));